export let CHANNEL_TYPES;
(function (CHANNEL_TYPES) {
  CHANNEL_TYPES["CHANNEL"] = "channel";
  CHANNEL_TYPES["YOUTUBE_FEED"] = "youtube-feed";
})(CHANNEL_TYPES || (CHANNEL_TYPES = {}));
//# sourceMappingURL=channel-types.js.map